import React  from 'react';
import { Modal } from '@/components/AntD';

import './index.scss';
import classNames from 'classnames';

export default function ExperienceModal(props) {
  const { open, onClose, type, remain, total } = props;

  return <Modal
    title="升级账号"
    open={open}
    centered
    footer={null}
    width={type === 'default' ? '400px' : '480px'}
    zIndex={9999999}
    className={classNames('ExperienceModal', `ExperienceModal_${type}`)}
    onCancel={() => {
      onClose && onClose();

    }}
  >
    <div className="ExperienceModal-innaer">
      {
        type === 'default' && <div className="default-title">扫码添加客服进行升级</div>
      }
      {/* 合成字数不够 */}

      {
        type === 'compound' && <div className="file-title">
          <div>本账号为试用账号，每日合成书稿不超过{total || 5000}字（今日剩余<span>{remain || 0}</span>字）<br />
            升级账号可无限合成</div>
          <div> 扫码添加客服进行升级</div>
        </div>

      }
      {/* 无权限 */}
      {
        type === 'auth' && <div className="file-title">
          <div>您的试用体验时间已经结束，请扫码添加客服进行升级。</div>
          <div />
        </div>

      }

      <div className="qrcode-wrapper">
        <img src="https://oss.5rs.me/oss/uploadfe/jpg/aae7ff02e04d2e01f9daa63ca01c19de.jpg" />
      </div>
    </div>
  </Modal>;
}

ExperienceModal.defaultProps = {
  type: 'default' //default|file|text
};